import axios from "axios";

// The staff console talks to the same backend as the tenant sites, but under
// /api/platform with its own session token. It sends no X-Tenant-Domain header.
export const CONSOLE_TOKEN_KEY = "riskConsoleToken";
export const CONSOLE_EMAIL_KEY = "riskConsoleEmail";

const read = (key) => {
  try { return localStorage.getItem(key); } catch { return null; }
};

export const getSession = () => {
  const token = read(CONSOLE_TOKEN_KEY);
  return token ? { token, email: read(CONSOLE_EMAIL_KEY) } : null;
};

export const saveSession = (token, email) => {
  try {
    localStorage.setItem(CONSOLE_TOKEN_KEY, token);
    localStorage.setItem(CONSOLE_EMAIL_KEY, email);
  } catch {}
};

export const clearSession = () => {
  try {
    localStorage.removeItem(CONSOLE_TOKEN_KEY);
    localStorage.removeItem(CONSOLE_EMAIL_KEY);
  } catch {}
};

const consoleApi = axios.create({
  baseURL: `${(process.env.REACT_APP_API_URL || "https://risk-api.africacodefoundry.com/").replace(/\/$/, "")}/api/platform`,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

consoleApi.interceptors.request.use((config) => {
  const session = getSession();
  if (session) config.headers.Authorization = `Bearer ${session.token}`;
  return config;
});

consoleApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const signingIn = error.config?.url?.startsWith("/auth/");
    if (error.response?.status === 401 && !signingIn) {
      clearSession();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Message to show for a failed request; never raw server errors
export const errorMessage = (error, fallback = "Something went wrong. Please try again.") => {
  const status = error?.response?.status;
  if (!error?.response) return "Can't reach the server. Check your connection and try again.";
  if (status >= 500) return fallback;
  return error.response.data?.message || fallback;
};

export default consoleApi;
